import { Component, computed, Signal, signal, WritableSignal, inject } from '@angular/core';
import { OffcanvasBaseComponent } from '../../../../../shared/components/offcanvas/offcanvas-base/offcanvas-base.component';
import { OffcanvasHeaderBtnComponent } from '../../../../../shared/components/offcanvas/offcanvas-header-btn/offcanvas-header-btn.component';
import { Router } from '@angular/router';
import { CardTopupFormComponent } from '../topup-form-base/card-topup-form.component';
import { AvatarComponent } from '../../../../../shared/components/avatar/avatar.component';
import { EmptyIndicatorPipe } from '../../../../../shared/pipes/empty-indicator.pipe';
import { SlicePipe } from '@angular/common';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { NgSelectCardOptionTemplateComponent } from '../shared/ng-select-card-dropdown-options/ng-select-card-option-template.component';
import {
  StatusBadgeComponent,
  statusBadgeDepartments,
} from '../../../../../shared/components/status-badge/status-badge.component';
import { CardTopup } from '../../../../../_interfaces/card-topups.interface';
import { CardTopupsService } from '../../../../../_services/topup-service/card-topups.service';
import { BoFormsModule } from '@bo/ng-forms';
import { Card, CardType } from '../../../../../_interfaces/cards.interface';
import { NgSelectCardLabelTemplateComponent } from '../shared/ng-select-card-dropdown-labels/ng-select-card-label-template.component';
import { AlertModule } from 'ngx-bootstrap/alert';
import { OffcanvasService } from '../../../../../_services/offcanvas-service/offcanvas.service';

@Component({
  selector: 'app-edit-add-recurring-topup',
  imports: [
    OffcanvasBaseComponent,
    OffcanvasHeaderBtnComponent,
    CardTopupFormComponent,
    AvatarComponent,
    EmptyIndicatorPipe,
    NgSelectCardOptionTemplateComponent,
    NgSelectComponent,
    SlicePipe,
    StatusBadgeComponent,
    BoFormsModule,
    NgSelectCardLabelTemplateComponent,
    NgOptionTemplateDirective,
    AlertModule,
    NgLabelTemplateDirective,
  ],
  templateUrl: './card-topup-canvas.component.html',
})
export class CardTopupCanvasComponent {
  readonly router = inject(Router);
  readonly cardTopupsService = inject(CardTopupsService);
  readonly offcanvasService = inject(OffcanvasService);

  public returnUrl: Signal<string> = computed<string>(() =>
    this.router.url.includes('recurring') ? '/card-topups/recurring' : '/card-topups/scheduled',
  );
  public isRecurring: Signal<boolean> = computed<boolean>(() => this.router.url.includes('recurring'));
  readonly cardsList = computed(() => this.cardTopupsService.cardsList());

  protected title = computed(() => {
    const action = this.selectedRule() ? 'Edit' : 'Create';
    const type = this.isRecurring() ? 'recurring' : 'scheduled';
    return `${action} ${type} topup`;
  });

  selectedCard: Card | null = null;

  selectedRule: WritableSignal<CardTopup | null> = signal(null);

  handleRuleData($event: CardTopup | null) {
    this.selectedRule.set($event);
  }

  editRule(id: number | null | undefined) {
    this.offcanvasService.offCanvasNavigate(`/card-topups/recurring/edit/${id}`);
  }

  // Custom search function for ng-select to search across card name and holder name
  customSearchFn = (term: string, item: Card) => {
    const searchTerm = term.toLowerCase();

    // Search in card name (for subscription cards)
    if (item.name?.toLowerCase().includes(searchTerm)) {
      return true;
    }

    // Search in holder's first name
    if (item.holder?.first_name?.toLowerCase().includes(searchTerm)) {
      return true;
    }

    // Search in holder's last name
    if (item.holder?.last_name?.toLowerCase().includes(searchTerm)) {
      return true;
    }

    // Search in full name (first + last)
    const fullName = `${item.holder?.first_name || ''} ${item.holder?.last_name || ''}`.toLowerCase().trim();
    return fullName.includes(searchTerm);
  };

  protected readonly CardType = CardType;
  protected readonly statusBadgeDepartments = statusBadgeDepartments;
}
